// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c996504e","977":"2eb86544"}[chunkId] + ".chunk.js";
};